/**
 * Material name list for the Edit Type material editors.
 *
 * `MATERIAL_NAME_OPTIONS` stays as the static seed for non-hook contexts.
 * Components inside the document tree should prefer `useMaterialNameOptions()`,
 * which merges the live project registry (Manage > Materials) on top, so
 * dropdowns always match the current document.
 */

import { useMemo } from 'react';
import { useBIMStore } from '../../state/useBIMStore';
import { STANDARD_MATERIALS } from '../../tools/MaterialTakeoffTool';

const EXTRA_MATERIAL_NAMES = [
    'Generic',
    'Gypsum',
    'Metal Stud',
    'Air Space',
    'Wood',
    'Aluminum',
    'Concrete - Cast-in-Place',
    'Masonry - Concrete Block',
];

export const MATERIAL_NAME_OPTIONS: string[] = Array.from(new Set([
    ...EXTRA_MATERIAL_NAMES,
    ...STANDARD_MATERIALS.map(m => m.name),
])).sort((a, b) => a.localeCompare(b));

/** Live dropdown names: project registry first, legacy fallback always present. */
export function useMaterialNameOptions(): string[] {
    const materials = useBIMStore((state) => state.project.materials);
    return useMemo(() => {
        const names = new Set<string>(EXTRA_MATERIAL_NAMES);
        materials?.forEach((m) => names.add(m.name));
        STANDARD_MATERIALS.forEach((m) => names.add(m.name));
        return Array.from(names).sort((a, b) => a.localeCompare(b));
    }, [materials]);
}
